import { Container, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import {
    Add as AddIcon, BackspaceOutlined as BackspaceOutlinedIcon,
    Delete as DeleteIcon, Search as SearchIcon
} from '@material-ui/icons';
import MUIDataTable from "mui-datatables";
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import Select from '../../components/Form/Select';
import Success from '../../components/Form/Success';
import TextField from '../../components/Form/TextField';
import AlertDialog from '../../components/ui/AlertDialog';
import ButtonUI from '../../components/ui/ButtonUI';
import LoadingUI from '../../components/ui/LoadingUI';
import PageTitle from '../../components/ui/PageTitleUI';
import { useAuth } from '../../hooks/auth';
import ShedApi from '../../services/ShedApi';
import getDefaultGridOptions from '../../utils/componentUtils';
import permissions from '../../utils/Permissions';
import useKeypress from '../../utils/useKeypress';
import ShedForm from './ShedForm';
import { useStyles } from './Style';
import BoxSlide from '../../components/ui/BoxSlideUI'

const opcoes = [
    { url: '/Shed', descricao: 'Incluir', state: {openPanelOnLoad: true}},
    { url: '/Shed', descricao: 'Pesquisar', state: {}}
]

interface Params {
    openPanelOnLoad: boolean;
}

const Shed: React.FC = () => {
    const classes = useStyles();
    const location = useLocation<Params>();
    const [sheds, setSheds] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [openedPainel, setOpenedPainel] = React.useState(false);
    const [shedId, setShedId] = useState<number>(0);
    const { user, hasPermission } = useAuth();
    const { t: _t } = useTranslation("General");
    const { t } = useTranslation("Shed");
    const history = useHistory();
    const { enqueueSnackbar } = useSnackbar();
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (!hasPermission(permissions.SHED.Search))
            history.replace('NoPermission');

        onSubmit(getValues())
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, user]);

    
    //Campos do Form
    interface IFormPanel {
        shedCode: any;
        shedType: any;
    }

    //Metodos do form:
    const { handleSubmit, reset, control, getValues } = useForm<IFormPanel>({
        defaultValues: {
            shedCode: '',
            shedType: {}
        }
    });

    const shedTypeList = [{code: '', label: ''}, {code: 'C', label: t('type_C')}, {code: 'D', label: t('type_D')}];

    const columns = [
        {
            name: 'id',
            options: {
                display: false,
            }
        },
        {
            name: 'code',
            label: String(t('code')),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: 'type',
            label: String(t('type')),
            options: {
                setCellProps: () => ({
                    align: "left"
                }),
                customBodyRender: (value: any) => {
                    return t("type_" + value);
                }
            }
        },
        {
            name: "",
            options: {
                setCellProps: () => ({
                    align: "right"
                }),
                disableClick: true,
                sort: false,
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
                    renderButtons(tableMeta.rowData[0])
                )
            }
        },     
        
    ]

    const renderButtons = (id: any) => {
        return (
            <AlertDialog
                dialogTitle={_t("dialogDeleteTitle")}
                dialogContentText={_t("dialogDeleteContentText")}
                cancelTextButton={_t("cancelDeleteTextButton")}
                confirmTextButton={_t("confirmDeleteTextButton")}
                confirmDialogFunction={() => { handleDeleteItem(id); }}
                Button={
                    <IconButton size='small' edge="end" disabled={!hasPermission(permissions.SHED.Delete)}>
                        <DeleteIcon />
                    </IconButton>
                }
            />
        );
    }

    function handleDeleteItem(id: number) {
        setLoading(true)
        ShedApi.delete(id)
            .then(result => {
                enqueueSnackbar(_t("returnSubmitDeleteFormSuccess"), { variant: 'success' });
            }).finally(() => {
                onSubmit(getValues());
            });
    };

    useKeypress('Escape', () => {
        setOpenedPainel(false);
    });

    useEffect(() => {
        setSheds([]);
    }, []);

    const onSubmit = async (data: any) => {
        setLoading(true);

        data.pageSize = 10000;
        data.shedType = data.shedType.code;
        data.code = data.shedCode;
        data.plantId = user.company.plantID;

        ShedApi.search(data)
            .then(result => {
                if (result && result.items) {
                    setSheds(result);
                }
                else {
                    setSheds([]);
                }
            }).catch(() => {
                setSheds([]);
            }).finally(() => {
                setLoading(false);
            });
    };

    const cleanFilters = () => {
        reset({
            shedCode: '',
            shedType: '',
        });
    };

    const handleOpenPanelChange = (id: any) => {
        setShedId(id);
        setOpenedPainel(true);
    };

    const callbackDialogHandle = () => {
        setOpenedPainel(false);
        handleSubmit(onSubmit);
    }

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: sheds?.items ? 'pointer' : ''
                }
            }
        }
    })

    useEffect(() => {
        if (location.state?.openPanelOnLoad)
        {
            setOpenedPainel(true); 
            setShedId(0);
        }
    }, [location.state?.openPanelOnLoad])
    
    if (success)
        return (
            <Container maxWidth={false} component="main">
                <div className={classes.rootContent}>
                    <div className={classes.paper}>
                        <Success opcoes={opcoes}/>
                    </div>
                </div>
            </Container>
        )
    else
    return (
        <Container maxWidth={false} component="main">

            

            <BoxSlide width='45%' isOpen={openedPainel} onClose={() => { setOpenedPainel(false); }}>
                <ShedForm shedId={shedId} clickHandlerCalbkack={callbackDialogHandle} handleSetSuccess={setSuccess} clickHandlerClose={() => { setOpenedPainel(false); setShedId(0); }}  />
            </BoxSlide>

            <PageTitle title={t("pageTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>

                    <form translate={undefined} onSubmit={handleSubmit(onSubmit)}  >

                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearch")}
                                </Typography>

                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI disabled={!hasPermission(permissions.SHED.Add)} color="secondary" onClick={() => { setOpenedPainel(true); setShedId(0) }} startIcon={<AddIcon />}>{_t("add")}</ButtonUI>
                                <ButtonUI onClick={() => cleanFilters()} startIcon={<BackspaceOutlinedIcon />}>{_t("clean")}</ButtonUI>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{_t("search")}</ButtonUI>
                            </Grid>
                        </Grid>

                        <Divider style={{ marginTop: '10px' }} />

                        <Grid container spacing={1}>

                            <Grid item xs={2}>
                                <TextField label={t("code")} name="shedCode" control={control} inputProps={{maxLength: 6}} fullWidth />
                            </Grid>

                            <Grid item xs={2}>
                                <Select
                                    label={t("type")} 
                                    name="shedType" 
                                    control={control} 
                                    options={shedTypeList}
                                    style={{width: '100%'}}
                                />
                            </Grid>

                            <Grid item xs={8}>
                            </Grid>

                        </Grid>
                    </form>

                    {
                        loading ? <LoadingUI /> :
                            <MuiThemeProvider theme={myTheme}>
                                <MUIDataTable
                                    title=""
                                    data={sheds?.items}
                                    columns={columns}
                                    options={{
                                        ...getDefaultGridOptions(_t),
                                        serverSide: false,
                                        pagination: sheds?.items ? true : false,
                                        sort: sheds?.items ? true : false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                        onCellClick: (_colData, { colIndex, dataIndex }) => {
                                            if (hasPermission(permissions.SHED.Edit))
                                                if ((sheds && sheds.items) && colIndex < 3) {
                                                    handleOpenPanelChange(sheds.items[dataIndex].id);
                                                }
                                        },
                                    }}
                                />
                            </MuiThemeProvider>
                    }
                </div>
            </div>
        </Container>
    )
}
export default Shed;
